export default {
  outList: [
    {
      light_point_1:[
        {
          title: '第五代ACTECO 1.5TGDI',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '高效混动专用发动机'
        },
        {
          title: '无级超级电混DHT',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: '纯电驾感，高效节能'
        },
        {
          title: '混动智电管理系统',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '超长续航，CLTC纯电续航127km',
          text2: 'WLTC综合续航里程1400+km',
        }
      ],
      light_point_2:[
        {
          title: '百公里7s级加速',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '动力随叫随到，出行游刃有余'
        },
        {
          title: '博世IPB智能集成制动系统',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: ''
        }
      ],
      light_point_3:[
        {
          title: '全球五星标准安全设计',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '80%高强度钢+20.6%热成型钢',
          text2: '家人出行的移动安全堡垒',
        },
        {
          title: '360°环抱式10气囊防护',
          type: 'image',
          video: '',
          image: 'lightPoint/3/2.jpg',
          text: '不同角度的碰撞保护',
          text2: '为家人提供全方位守护',
        },
        {
          title: '守护者电池安全系统',
          type: 'image',
          video: '',
          image: 'lightPoint/3/3.jpg',
          text: '超高强度电池包安全结构',
          text2: 'IP68级防水防尘级别，抗热、抗撞、防水',
        }
      ],
      light_point_4:[
        {
          title: 'V2L对外放电功能',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '随时随地与家人尽情享户外趣味'
        },
        {
          title: '超级绿能闪充',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '19min，30%充至80%，畅享无忧出行'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '24.6吋悬浮式双联屏',
          type: 'image',
          video: '',
          image: 'lightPoint/4/1.jpg',
          text: 'Lion5.0 AI科技智慧座舱',
          text2: '智能交互体验，愉悦出行享受',
        },
      ],
      light_point_2:[
        {
          title: '高通骁龙8155智能芯片',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '秒开机，丝滑不卡顿'
        }
      ],
      light_point_3:[
        {
          title: 'C-PURE净立方健康座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/3.jpg',
          text: '纯净呼吸系统，随时随地保持空气清新'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '第五代ACTECO 1.5TGDI',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '高效混动专用发动机'
    },
    {
      title: '无级超级电混DHT',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '纯电驾感，高效节能'
    },
    {
      title: '混动智电管理系统',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '超长续航，CLTC纯电续航127km',
      text2: 'WLTC综合续航里程1400+km',
    },
    {
      title: 'V2L对外放电功能',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '随时随地与家人尽情享户外趣味'
    }
  ],
  tab2: [
    {
      title: '百公里7s级加速',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '动力随叫随到，出行游刃有余'
    },
    {
      title: '博世IPB智能集成制动系统',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: ''
    },
    {
      title: '超级绿能闪充',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '19min，30%充至80%，畅享无忧出行'
    }
  ],
  tab3: [
    {
      title: '全球五星标准安全设计',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '80%高强度钢+20.6%热成型钢',
      text2: '家人出行的移动安全堡垒',
    },
    {
      title: '360°环抱式10气囊防护',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '不同角度的碰撞保护',
      text2: '为家人提供全方位守护',
    },
    {
      title: '守护者电池安全系统',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '超高强度电池包安全结构',
      text2: 'IP68级防水防尘级别，抗热、抗撞、防水',
    }
  ],
  tab4: [
    {
      title: '24.6吋悬浮式双联屏',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: 'Lion5.0 AI科技智慧座舱',
      text2: '智能交互体验，愉悦出行享受',
    },
    {
      title: '高通骁龙8155智能芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '秒开机，丝滑不卡顿'
    },
    {
      title: 'C-PURE净立方健康座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '纯净呼吸系统，随时随地保持空气清新'
    },
    {
      title: 'LDW车道偏离辅助系统',
      type: 'image',
      video: '',
      image: 'lightPoint/4/4.jpg',
      text: ''
    },
    {
      title: 'AEB自动紧急制动系统',
      type: 'image',
      video: '',
      image: 'lightPoint/4/5.jpg',
      text: ''
    }
  ]
}
